import { css, cx } from '@fable/theme'

interface Props {
  position: 'left' | 'center' | 'right'
}

export const FlowerStalk = ({ position }: Props) => {
  const color = '#4F8011'

  const getPath = () => {
    switch (position) {
      case 'left':
        return (
          <path
            d="m13.24,51.39C13.24,34.76,1.5,3.79,1.5,3.79"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={3}
          />
        )
      case 'center':
        return (
          <path
            d="m13.24,1.5v49.89"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={3}
          />
        )
      case 'right':
        return (
          <path
            d="m13.24,51.39c0-16.63,11.74-47.6,11.74-47.6"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeMiterlimit={10}
            strokeWidth={3}
          />
        )
    }
  }

  return (
    <svg
      className={cx(
        'anim__flower-stalk',
        css`
          width: 100%;
          will-change: transform;
        `
      )}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.48 52.89"
    >
      {getPath()}
    </svg>
  )
}
